var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-card', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("集點卡管理")]), _c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-1",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabled_branch_select
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selected_branch,
      callback: function callback($$v) {
        _vm.selected_branch = $$v;
      },
      expression: "selected_branch"
    }
  }), _vm.checkPermission([_vm.consts.REWARD_CARD_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'RewardCardCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增集點卡")]) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入集點卡名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-card-text', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.rewardCards,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(start_end_time)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.start_at)) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.dateFormatter(data.item.end_at)) + " ")])];
      }
    }, {
      key: "cell(branch_id)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.getBranchName(data.item.branch_id)))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.REWARD_CARD_LIST_VIEW]) ? _c('copy-url-button', {
          staticClass: "mr-1",
          attrs: {
            "url": _vm.generateLiffUrl("rewards-card/".concat(data.item.id)),
            "title": data.item.title
          },
          scopedSlots: _vm._u([{
            key: "qrcode",
            fn: function fn() {
              return [_c('div', {
                staticClass: "d-flex flex-column align-items-center"
              }, [_c('vue-qr', {
                ref: "qrcode",
                attrs: {
                  "text": _vm.generateLiffUrl("rewards-card/".concat(data.item.id))
                }
              })], 1)];
            },
            proxy: true
          }, {
            key: "qrcode-download-button",
            fn: function fn() {
              return [_c('b-button', {
                attrs: {
                  "variant": "primary"
                },
                on: {
                  "click": function click($event) {
                    return _vm.downloadQRCode(data.item.title);
                  }
                }
              }, [_vm._v(" 下載QRCode ")])];
            },
            proxy: true
          }], null, true)
        }) : _vm._e(), _vm.checkPermission([_vm.consts.POINT_LIST_VIEW]) ? _c('b-dropdown', {
          staticClass: "mr-1",
          attrs: {
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'PointLogList',
              query: {
                merchant_id: data.item.merchant_id,
                event_id: data.item.event_id,
                sort_by: 'created_at',
                order_by: 'desc'
              }
            }
          }
        }, [_vm._v(" 集點與兌換紀錄 ")]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'PersonalPoint',
              query: {
                merchant_id: data.item.merchant_id,
                event_id: data.item.event_id,
                sort_by: 'name',
                order_by: 'asc'
              }
            }
          }
        }, [_vm._v(" 參與會員紀錄 ")])], 2) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_MISSION_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'RewardMissionList',
              params: {
                reward_card_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-paw"
        }), _vm._v(" 任務 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_GIFT_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-success",
            "to": {
              name: 'RewardGiftList',
              params: {
                reward_card_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-gift"
        }), _vm._v(" 獎項 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_CARD_LIST_VIEW]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'RewardCardView',
              params: {
                reward_card_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_CARD_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'RewardCardEdit',
              params: {
                reward_card_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.REWARD_CARD_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteRewardCard(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:current-page": function updateCurrentPage($event) {
        return _vm.$set(_vm.query, "page", $event);
      },
      "update:perPage": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      },
      "update:per-page": function updatePerPage($event) {
        return _vm.$set(_vm.query, "per_page", $event);
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }